import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { WorkspaceFileUserStatus } from '@common/workspace/enums/workspace-file-user-status.enum';
import { WorkspaceFileUser } from '@common/workspace/models/workspace-file-user.model';
import { WorkspaceFile } from '@common/workspace/models/workspace-file.model';
import { CurrentService } from '@portal-core/current/services/current.service';

@Component({
  selector: 'mc-workspace-file-user-status-avatar-indicator',
  templateUrl: './workspace-file-user-status-avatar-indicator.component.html',
  styleUrls: ['./workspace-file-user-status-avatar-indicator.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspaceFileUserStatusAvatarIndicatorComponent implements OnChanges {
  @Input() workspaceFiles: WorkspaceFile[];
  @Input() workspaceFileUser: WorkspaceFileUser;

  WorkspaceFileUserStatus: typeof WorkspaceFileUserStatus = WorkspaceFileUserStatus;

  isActive: boolean;
  isCurrentUser: boolean;

  constructor(private currentService: CurrentService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.workspaceFileUser) {
      this.isActive = this.workspaceFiles?.some(workspaceFile => {
        return workspaceFile.activeUsers?.some(collabUser => collabUser.userId === this.workspaceFileUser.userId)
      });
      this.isCurrentUser = this.workspaceFileUser.userId === this.currentService.getUserId();
    } else {
      this.isActive = false;
      this.isCurrentUser = false;
    }
  }
}
